import React, { useEffect, useRef } from "react";

import YoutubeIcon from '../assets/youtube_icon.svg';
import styled from "styled-components";

import {loginToYoutubeChatManager} from '../utils/loginHelper';
import { loginUser } from "../utils/loginHelper";
import axios from 'axios';
let backendAPIURL = 'https://be.namasteapis.com/api/v1';
//let backendAPIURL = 'http://localhost:4040/api/v1';



export const axiosCall = (route:any) => {
    console.log('request:- ' + JSON.stringify(route));
  return new Promise(async (resolve, reject) => {
    return axios(route)
      .then((res) => {
        //console.log('Response:- ' + JSON.stringify(res));
        resolve(res);
      })
      .catch((error) => {
        //console.log('error:- ' + error);
        reject(error.response);
      });
  });
};

const ConnectButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: static;
  height: 45px;
  cursor: pointer;
  background: #FFFFFF;
  border-radius: 12px;
`
const ConnectButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  border-radius: 12px;
`



export async function loginYoutubeAPIChatbot(
    youtubeCode: any, socketId:any) {
    const request = {
        method: 'POST',
        url: `${backendAPIURL}/auth/youtube/login-chatbot/`,
        'data': {
            'code':youtubeCode,
            'socketId': socketId,
            'device': 'web'
        }
    };
    let res = await axiosCall(request);
    if (res.data.success) {
        return res.data;
    }
    else {
        return;
    }
}


export default function YoutubeChatBotManager(props:any) {

    const handleConnectYoutubeClicked = ()=>{
        loginToYoutubeChatManager();
    }

        
    useEffect(()=>{
        (async ()=>{
            const urlSearchParams:any = new URLSearchParams(
                window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            let code = params['code'];
            let socketId = params['state'];
            let accessToken = await loginYoutubeAPIChatbot(code, 'gg');
            console.log('accessTokengg', accessToken)
        })();
    },[]);

    
    return (
        <ConnectButtonDiv
        style={{
            background: 'linear-gradient(95.39deg, #FE0000 3.78%, #FA00FF 100%)',
            marginBottom:10,
            width: 500
        }}
            onClick={()=>{
                handleConnectYoutubeClicked();
            }}>
            <img src={YoutubeIcon} style={{
                marginRight:14,
                width: 29,
                height: 20
            }} />
            <ConnectButtonTextSpan>
                LOG IN WITH YOUTUBE
            </ConnectButtonTextSpan>
        </ConnectButtonDiv>
    );
}
